/* eslint-disable no-nested-ternary */
import * as React from 'react';
import {
  Grid, Box, Typography,
  Paper,
} from '@material-ui/core';
import WorkViewSet from '../SetView';
import type { IFilter, IWorkViewPrimaryGroup, IWorkViewPrimaryGroupData } from '../WorkViewInterfaces';

interface HorizontalLayoutProp {
  primaryGroups: IWorkViewPrimaryGroup[];
  primaryGroupData: IWorkViewPrimaryGroupData[];
  filter: IFilter;
}

const HorizontalLayout: React.FC<HorizontalLayoutProp> = ({ primaryGroups, primaryGroupData, filter }) => (
  <Paper>
    {primaryGroups.map((primaryGroup, index) => (
      <>
        <Box p={2} style={{ borderBottom: index !== primaryGroups.length - 1 ? '1px solid #F2F2F2' : 'none' }}>
          <Grid item xs={12}>
            <Typography variant="h6">
              {primaryGroup.name}
            </Typography>
            <Typography variant="body2">
              {`${primaryGroupData[index]?.totalItems.toString()} Total Items`}
            </Typography>
            <Box pt={2} pb={2}>
              <Grid container spacing={2}>
                {primaryGroup.sets
                  ? (
                    primaryGroup.sets.map((set, setIndex) => (
                      <Grid item>
                        <WorkViewSet
                          setName={set.name}
                          displayStyle={set.displayStyle}
                          isColored={set.color}
                          color={filter?.color}
                          setData={primaryGroupData[index]?.sets[setIndex].totalItems}
                        />
                      </Grid>
                    ))) : (
                      <Grid item />
                  )}
              </Grid>
            </Box>
          </Grid>
        </Box>
      </>
    ))}
  </Paper>
);

export default HorizontalLayout;
